import {Box} from "@mui/material";
import {Outlet} from "react-router-dom";
import Sidebar from "../components/Sidebar/Sidebar";
import styles from "./MainLayout.module.css";

const MainLayout = () => {
  return (
    <Box className={styles.container}>
      <Sidebar />

      <Box component="main" className={styles.content}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default MainLayout;
